import React from 'react';
import { InView } from 'react-intersection-observer';

// Wrapper around react-intersection-observer to isolate the dependency.
// Props:
//   onChange(isVisible: boolean) — called when visibility changes
//   partialVisibility: boolean   — trigger as soon as any part is visible (default: false = fully visible)
//   children: ReactNode
const VisibilitySensor = ({ onChange, partialVisibility = false, children }) => (
	<InView
		threshold={partialVisibility ? 0 : 1}
		onChange={onChange}
	>
		{({ ref }) => (
			<div ref={ref}>
				{children}
			</div>
		)}
	</InView>
);

export default VisibilitySensor;
